import React from "react";
import PropTypes from "prop-types";
import { getLinkToProject } from "../../common/util/pathUtils";

const SingleColumn = ({ project, showLearnMore }) => {
    const linkToProject = getLinkToProject(project.code);

    return 	<div className="w-100 con-justify text-center">
				<div className="up">
					<div className="img-cover img-1 w-100">
						<a href={linkToProject}><img src={project.thumbnailImageUrl} /></a>
					</div>
					<div className="py-2">
						<h6 className="text-primary xsml">{project.locationDescription}</h6>
						<h5 className="mb-3"><a href={linkToProject} className="text-white lrg line-27">{project.name}</a></h5>
						<p className="xsml mt-0 line-22 text-white-50">{project.shortDescription}</p>
					</div>
				</div>
				<div className="down">
					{showLearnMore &&
					<a href={linkToProject} className="project-btn font-700 xsml">Learn more</a>
					}
				</div>
			</div>
}

SingleColumn.propTypes = {
    project: PropTypes.object,
    showLearnMore: PropTypes.bool
}

export default SingleColumn;